<template>
<layout-content>
  <template #toolbar>
    <el-cascader
      v-model="selectSiteDevice"
      size="small"
      :options="filterSites"
      :show-all-levels="false"
      :props="props"
      placeholder="请选择站房设备"
      @change="onCheck"
    ></el-cascader>

    <!-- <el-button
      :disabled="canNotSearch"
      type="success"
      size="small"
      icon="el-icon-download"
      @click="onModelBtnClick()"
    >下载导入模板</el-button>

    <el-upload
      ref="upload"
      :action="`/multiple/integral/upload`"
      :http-request="onUploadBtnClick"
      :data="uploadQuery"
      :multiple="false"
      :show-file-list="false"
      :drag="false"
      accept=".csv,.xlsx"
      style="display:inline-block;"
    >
      <el-button :disabled="canNotSearch" type="primary" icon="el-icon-upload" size="small"
        >导入</el-button
      >
    </el-upload> -->

    <el-button
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="getDataList()"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <el-table
        ref="table"
        :data="list"
        height="100%"
        border
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table"
        style="width:100%"
      >
        <el-table-column label="序号" width="50" align="center" fixed>
          <template v-slot="{$index}">{{$index + 1}}</template>
        </el-table-column>
        <el-table-column prop="orgName" label="组织" align="center">
          <template v-slot="{row}">{{row.orgName ? row.orgName : '--'}}</template>
        </el-table-column>
        <el-table-column prop="siteId" label="站点" align="center">
          <template v-slot="{row}">{{filterSiteDeviceMap[row.siteId] ? filterSiteDeviceMap[row.siteId].name : '--'}}</template>
        </el-table-column>
        <el-table-column prop="siteDeviceId" label="仪器名称" align="center">
          <template v-slot="{row}">{{(filterSiteDeviceMap[row.siteId] && filterSiteDeviceMap[row.siteId].devicesMap[row.siteDeviceId] ) ? filterSiteDeviceMap[row.siteId].devicesMap[row.siteDeviceId].name : '--'}}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="导入时间" align="center">
          <template v-slot="{row}">{{row.createTime ? new Date(row.createTime).format('YYYY/MM/DD HH:mm:ss') : '--'}}</template>
        </el-table-column>
        <el-table-column prop="beginTime" label="开始时间" align="center">
          <template v-slot="{row}">{{row.beginTime ? new Date(row.beginTime).format('YYYY/MM/DD HH:mm:ss') : '--'}}</template>
        </el-table-column>
        <el-table-column prop="endTime" label="结束时间" align="center">
          <template v-slot="{row}">{{row.endTime ? new Date(row.endTime).format('YYYY/MM/DD HH:mm:ss') : '--'}}</template>
        </el-table-column>
        <el-table-column prop="userName" label="用户" align="center" />
        <el-table-column prop="state" label="状态" align="center">
          <template v-slot="{row}">{{row.state ? '导入成功' : '导入失败'}}</template>
        </el-table-column>
      </el-table>
    </data-wrapper>
  </template>

  <template #footer>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[20, 50, 100, 200, 500]"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next"
      background
      style="float: right;"
    >
    </el-pagination>
  </template>

  <template #editor>
    <editor ref="editor" @save="getDataList" />
  </template>
</layout-content>
</template>

<script>
import Editor from './Editor'
import BaseSiteFactorData from '../../BaseSiteFactorData'
import CSVDownloader from '../../../utils/CSVDownloader'
import DataWrapper from '../../../components/Data/DataWrapper'
import DeviceCategoryConfig from '../../../model/DeviceCategoryConfig'

export default {
  name: 'OperationsDoubleIntegralUpload',
  routeInfo: {
    label: '重积分导入日志',
    icon: 'fa fa-eye'
  },
  extends: BaseSiteFactorData,
  components: {DataWrapper, Editor},
  data () {
    return {
      props: {
        children: 'devices',
        value: 'id',
        label: 'name'
      },
      selectSiteDevice: [],
      uploadQuery: {
        siteId: '',
        siteDeviceId: ''
      },
      factorStandardName: [],
      currentPage: 1,
      total: 0,
      pageSize: 20,
      dataList: [],
      list: []
    }
  },
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NMHC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HCHO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PAN_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HEAVY_METAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.SPAMS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.BLACK_CARBON_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.LIGHT_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ORGANIC_SULFUR_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.GONG_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PARTICLE_SIZE_SPECTRUM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false)
      ]
    },
    filterSiteDeviceMap () {
      let data = Object.values(this.filterSiteMap).reduce((siteMap, item) => {
        siteMap[item.id] = item

        siteMap[item.id].devicesMap = item.devices.reduce((map, el) => {
          map[el.id] = el

          return map
        }, {})

        return siteMap
      }, {})
      return data
    }
  },
  watch: {
    filterSites: {
      immediate: true,
      handler (newVal) {
        this.setSiteId(newVal)
      }
    }
  },
  methods: {
    onCheck (select) {
      this.uploadQuery = {
        siteId: select[0],
        siteDeviceId: select[1]
      }
      this.getDataList()
    },
    setSiteId (sites) {
      if (sites.length === 0) {
        return
      }

      let {uploadQuery} = this

      if (!uploadQuery.siteId) {
        this.selectSiteDevice = [
          sites[0].id,
          sites[0].devices[0].id
        ]
        this.uploadQuery = {
          siteId: sites[0].id,
          siteDeviceId: sites[0].devices[0].id
        }
      }
    },
    getData () {
    },
    getDataList () {
      this.changeLoadStatus(true)

      this.$api.Integral.getList(this.uploadQuery).then(backData => {
        if (backData.length === 0) {
          this.total = 0
          this.dataList = []
          this.list = []

          return false
        }

        this.dataList = Object.freeze(backData)
        this.total = backData.length

        if (this.total > this.pageSize) {
          for (let index = 0; index < this.pageSize; index++) {
            this.list.push(backData[index])
          }
        } else {
          this.list = backData
        }

        this.handleCurrentChange(1)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    // getFactorStandard () {
    //   this.changeLoadStatus(true)

    //   this.$api.FactorStandard.getList().then(backData => {
    //     this.getDataList()
    //     this.factorStandardName = backData
    //   }).catch(console.error).finally(() => {
    //     this.changeLoadStatus(false)
    //   })
    // },
    currentChangePage (list, currentPage) {
      let from = (currentPage - 1) * this.pageSize
      let to = currentPage * this.pageSize
      this.list = []

      for (; from < to; from++) {
        if (list[from]) {
          this.list.push(list[from])
        }
      }
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.currentChangePage(this.dataList, currentPage)
    },
    onUploadBtnClick (uploadObj) {
      this.changeLoadStatus(true)

      this.$api.Integral.upload(uploadObj)
        .then(backData => {
          this.setBackData(backData)
        })
        .catch(console.error)
        .finally(() => {
          this.changeLoadStatus(false)
        })
    },
    setBackData (backData) {
      let {factorMap, filterSiteMap, uploadQuery: {siteId}} = this

      if (backData.aliasSet && backData.aliasSet.length > 0) {
        // 取该站点所有因子Map
        let siteFactorsMap = filterSiteMap[siteId].devices.map(item => {
          return [...item.siteDeviceFactors]
        }).reduce((a, b) => a.concat(b)).reduce((map, el) => {
          map[el.factorId] = el
          return map
        }, {})

        let {factorIds} = backData
        let factors = factorIds.map(el => siteFactorsMap[el])

        this.onEditBtnClick({
          factors: factors,
          errorBackData: backData.aliasSet.map(el => {
            return {
              alias: el,
              factorId: ''
            }
          }),
          backData: backData,
          siteId: siteId,
          filterSiteMap: filterSiteMap
        })
      } else {
        if (backData.isSave) {
          if (backData.isDelete) {
            this.getDataList()
            this.$notify({
              type: 'success',
              position: 'bottom-right',
              message: `删除成功!`
            })
            return
          }
          this.getDataList()
          this.$notify({
            type: 'success',
            position: 'bottom-right',
            message: `导入成功! ${backData.errRatio ? '错误率：' + backData.errRatio + '%(<20%容错率)' : ''}`
          })
        } else if (backData.isSave === false) {
          let factorNames = backData.noSiteDeviceFactorIds.map(item => {
            return factorMap[item].name
          })

          this.$notify({
            type: 'error',
            position: 'bottom-right',
            message: `导入失败! ${backData.errRatio ? '错误率：' + backData.errRatio + '%(>20%容错率)' : ''}
              ${filterSiteMap[siteId].name}不包含${factorNames.join(',')}因子
            `
          })
        }
      }
    },
    // JSON 按属性去重 data（去重的JSON） Name（属性名）
    FilterByName (data, Name) {
      let dest = []

      for (let i = 0; i < data.length; i++) {
        let ai = data[i]

        if (i === 0) {
          dest.push(ai)
        } else {
          let filterData = dest.filter(function (e) {
            return e[Name] === ai[Name]
          })

          if (filterData.length === 0) {
            dest.push(ai)
          }
        }
      }
      return dest
    },
    onEditBtnClick (data) {
      this.$refs.editor.open(data)
    },
    onModelBtnClick () {
      let firstColumn = ['日期', '乙烷', '丙烷', '异丁烷', '正丁烷', '环戊烷', '异戊烷', '正戊烷']
      let data = [
        ['2022/08/10 1:00:00', '1', '2', '3', '1', '2', '3', '1'],
        ['2022/08/10 2:00:00', '1', '2', '3', '1', '2', '3', '1'],
        ['2022/08/10 3:00:00', '1', '2', '3', '1', '2', '3', '1'],
        ['2022/08/10 4:00:00', '1', '2', '3', '1', '2', '3', '1']
      ]

      CSVDownloader([firstColumn, ...data], '重积分数据上传模板')
    }
  },
  created () {
    this.getDataList()
    // this.getFactorStandard()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/08Operations/05Double-Integral-Upload/index.vue